export const contextKeys = ['blueprintArn']

export const initDataKeyList = ['gandalfToken', ...contextKeys] as const
export type initDataKeys = typeof initDataKeyList[number]
export type initDataType = { [key in initDataKeys]: string }
